"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appSelfLoader = exports.subAppSelfLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
// providers
const providers_1 = require("./providers");
const renderUtils_1 = require("../utils/renderUtils");
const initializers_1 = require("./initializers");
const subAppSelfLoader = async ({ id, API, app: App, reducers = {}, libraries = [], trackerConfig, featureFlagConfig, translationsConfig, setGlobalEventBus, }) => {
    const AppWithProviders = ({ oldData }) => ((0, jsx_runtime_1.jsx)(providers_1.SubAppSelfProviders, { children: (0, jsx_runtime_1.jsx)(App, { oldData: oldData }) }));
    const config = {
        verticalId: id,
        entrypoint: async (domElement, _store, _history, _initializedFeatures, _externalComponents, data) => {
            await (0, initializers_1.subAppInitializer)({ API, libraries, trackerConfig, featureFlagConfig, translationsConfig, setGlobalEventBus }, data);
            ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, { oldData: { store: _store, initializedFeatures: _initializedFeatures, externalComponents: _externalComponents } }), domElement);
        },
        reducers: reducers,
        wrapupConfig: {},
    };
    window.globals = window.globals || {};
    window.globals[id] = config;
    window.globalPromises?.[id]?.();
};
exports.subAppSelfLoader = subAppSelfLoader;
const appSelfLoader = async ({ API, app: App, libraries = [], trackerConfig, featureFlagConfig, translationsConfig }, data) => {
    const AppWithProviders = () => ((0, jsx_runtime_1.jsx)(providers_1.SubAppSelfProviders, { children: (0, jsx_runtime_1.jsx)(App, {}) }));
    await (0, initializers_1.subAppInitializer)({ API, libraries, trackerConfig, featureFlagConfig, translationsConfig }, data);
    ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), (0, renderUtils_1.getRootElement)());
};
exports.appSelfLoader = appSelfLoader;
//# sourceMappingURL=index.js.map